/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import yxhJsBridge from '@/shared/yxhJsBridge';
import { useUserStore } from '@/stores/modules/user';
import { useCreditStore } from '@/stores/modules/credit';
export default {
    __name: 'collect-sms',
    setup: function(__props) {
        var userStore = useUserStore();
        var creditStore = useCreditStore();
        var router = useRouter();
        yxhJsBridge.uploadFinaceSms();
        window.upLoadSmsSuc = /*#__PURE__*/ _async_to_generator(function() {
            var params, routeObj;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log('upLoadSmsSuc');
                        userStore.update({
                            smsPermission: 1
                        });
                        params = {
                            utdKey: userStore.commonData.utdKey,
                            darkCase: userStore.blackbox,
                            textAccess: userStore.smsPermission,
                            adTracker: userStore.gaid,
                            userTracker: userStore.appsflyerId
                        };
                        return [
                            4,
                            creditStore.reqSubmitCredit(params)
                        ];
                    case 1:
                        routeObj = _state.sent();
                        router.push(routeObj);
                        return [
                            2
                        ];
                }
            });
        });
        window.upLoadSmsFail = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(errMsg) {
                var params, routeObj;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log('upLoadSmsFail', errMsg);
                            userStore.update({
                                smsPermission: 0
                            });
                            params = {
                                utdKey: userStore.commonData.utdKey,
                                darkCase: userStore.blackbox,
                                textAccess: userStore.smsPermission,
                                adTracker: userStore.gaid,
                                userTracker: userStore.appsflyerId
                            };
                            return [
                                4,
                                creditStore.reqSubmitCredit(params)
                            ];
                        case 1:
                            routeObj = _state.sent();
                            router.push(routeObj);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(errMsg) {
                return _ref.apply(this, arguments);
            };
        }();
        onUnmounted(function() {
            window.upLoadSmsSuc = function() {};
            window.upLoadSmsFail = function() {};
        });
        return {
            __sfc: true,
            userStore: userStore,
            creditStore: creditStore,
            router: router
        };
    }
};
